module.exports = __webpack_public_path__ + "img/message-icon.f7044e55.svg";